export default __webpack_public_path__ + "static/media/carmake.ea88244a.jpg";